import { TypePolicies } from '@apollo/client';

export const thermostatSeparatePowerFieldPolicy = { merge: false };
// readingId is provenance, never normalized identity. Each snapshot replaces its
// predecessor, and the old combined metric fields remain in their own cache view.
export const thermostatPowerSnapshotTypePolicies: TypePolicies = {
  ThermostatLocalControlPermissionsV1: { keyFields: false },
  ThermostatLocalPermissionsValueV1: { keyFields: false },
  ThermostatLouvreControlV1: { keyFields: false },
  ThermostatSeparatePowerControlV1: { keyFields: false },
  ThermostatSeparatePowerModeMetricV1: { keyFields: false },
  ThermostatSeparatePowerStateMetricV1: { keyFields: false },
  ThermostatSeparateOperatingModeMetricV1: { keyFields: false },
  ThermostatSeparateOperatingStateMetricV1: { keyFields: false },
  ThermostatSeparateFanSpeedMetricV1: { keyFields: false },
  ThermostatSeparateAirDirectionMetricV1: { keyFields: false },
  ThermostatSeparatePowerCommandV1: { keyFields: false },
  ThermostatSeparatePowerTargetRequestV1: { keyFields: false },
};
